"use client";

import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BackButton({ className }: { className?: string }) {
  return (
    <Button
      variant="outline"
      onClick={() => window.history.back()}
      className={className}
    >
      <ArrowLeft className="w-4 h-4 mr-2" />
      <span className="font-semibold">BACK</span>
    </Button>
  );
}

